const HisSearch2 = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.8613 2.67188H6.36133C5.8309 2.67188 5.32219 2.88259 4.94711 3.25766C4.57204 3.63273 4.36133 4.14144 4.36133 4.67188V20.6719C4.36133 21.2023 4.57204 21.711 4.94711 22.0861C5.32219 22.4612 5.8309 22.6719 6.36133 22.6719H18.3613C18.8918 22.6719 19.4005 22.4612 19.7755 22.0861C20.1506 21.711 20.3613 21.2023 20.3613 20.6719V8.17188L14.8613 2.67188Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3613 2.67188V8.67188H20.3613"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8613 17.6719C13.242 17.6719 14.3613 16.5526 14.3613 15.1719C14.3613 13.7912 13.242 12.6719 11.8613 12.6719C10.4806 12.6719 9.36133 13.7912 9.36133 15.1719C9.36133 16.5526 10.4806 17.6719 11.8613 17.6719Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6113 16.9219L15.3613 18.6719"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisSearch2;
